import { render } from "./CompanyLayout.vue?vue&type=template&id=7933d2d4&scoped=true"
import script from "./CompanyLayout.vue?vue&type=script&lang=js"
export * from "./CompanyLayout.vue?vue&type=script&lang=js"

import "./CompanyLayout.vue?vue&type=style&index=0&id=7933d2d4&lang=scss&scoped=true"

import exportComponent from "/var/www/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7933d2d4"]])

export default __exports__